import styled from 'styled-components';
import { LinkButton, PrimaryButton } from '../CommonComponents/Button';
import Input from '../CommonComponents/Input';
import { RawButton } from '../CommonComponents/OPL/Button/Button.styles';

export const Wrapper = styled.div`
  padding: 32px 64px;
`;

export const CloseButton = styled(LinkButton)`
  position: absolute;
  top: 16px;
  right: 16px;
  font-size: 12px;
`;

export const Title = styled.h1`
  margin: 0;
  font-weight: 500;
  font-size: 24px;
  margin-bottom: 12px;
`;

export const ListTitle = styled.h3`
  margin: 24px 0;
  font-weight: 600;
  font-size: 16px;
`;

export const ListContainer = styled.ul`
  background-color: #f3f4f4;
  border: 1px solid #d8d8d8;
  border-radius: 4px;
  padding: 0;
  margin: 0;
  max-height: 400px;
  overflow: auto;
`;

export const ListItem = styled.li`
  display: flex;
  height: 32px;
  list-style: none;
  align-items: center;
  min-height: 48px;
  height: auto;
  padding: 0 8px;
  justify-content: space-between;
  &:not(:last-child) {
    border-bottom: 1px solid #d8d8d8;
  }
`;

export const Name = styled.div`
  padding: 8px;
  min-width: 60%;
  box-sizing: border-box;
`;

export const RelationType = styled.div`
  width: 100%;
  padding: 8px;
  text-align: left;
  flex: 1;
`;

export const DropdownButton = styled(RawButton)`
  width: 100%;
  padding: 8px;
  text-align: left;
  flex: 1;
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const RemoveButton = styled(LinkButton)<{ isRemovable: boolean }>`
  font-size: 12px;
  height: 100%;
  padding: 8px;
  min-width: 20%;
  box-sizing: border-box;

  ${props => {
    if (!props.isRemovable) {
      return `
      opacity: 0;
      cursor: default;
      `;
    }
    return ``;
  }}

  &:hover {
    color: #ed645f;
  }
`;

export const ButtonsContainer = styled.div`
  & > *:not(:last-child) {
    margin-right: 24px;
  }
`;

export const NameNote = styled.p`
  margin: 0 !important;
  font-style: italic;
  font-size: 12px;
`;

export const StyledInput = styled(Input)`
  width: 100%;
`;

export const InlineContent = styled.div`
  display: flex;
  height: 46px;
`;

export const SearchButton = styled(PrimaryButton)`
  width: 20%;
  margin-left: 8px;
`;
